import { createActions } from 'redux-actions'
import { get } from '../Infrastructure/Network'
import type { IAttribute } from '../Items/IItem'
import {
  getAttributesSucceeded,
  getCampaignCodeValidSucceeded,
  getCategoriesSucceeded,
  getShippingOptionsSucceeded,
} from './UI.reducer'
import { toast, type ToastOptions } from 'react-toastify'

const alertSettings: ToastOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: true,
  draggable: false,
}
const alertTypes = {
  default: 'default',
  success: 'success',
  info: 'info',
  warning: 'warning',
  error: 'error',
}

export const { getShippingOptionsRequested, getShippingOptionsRejected } =
  createActions({
    getShippingOptionsRequested: () => ({}),
    getShippingOptionsRejected: (error: any) => ({}),
  })

export const getShippingOptions = () =>
  get({
    url: `/item/shippingoptions`,
    initiated: getShippingOptionsRequested,
    fulfilled: getShippingOptionsSucceeded,
    rejected: getShippingOptionsRejected,
  })

export const { getCategoriesRequested, getCategoriesRejected } = createActions({
  getCategoriesRequested: () => ({}),
  getCategoriesRejected: (error: any) => ({}),
})

export const getCategories = () =>
  get({
    url: `/item/categories`,
    initiated: getCategoriesRequested,
    fulfilled: getCategoriesSucceeded,
    rejected: getCategoriesRejected,
  })

export const { getAttributesRequested, getAttributesRejected } = createActions({
  getAttributesRequested: () => ({}),
  getAttributesRejected: (error: any) => ({}),
})

export const getAttributes = (categoryId: string) =>
  get({
    url: `/item/attributes/${categoryId}`,
    initiated: getAttributesRequested,
    fulfilled: (attributes: IAttribute[]) =>
      getAttributesSucceeded({ categoryId, attributes }),
    rejected: getAttributesRejected,
  })

export const { getCampaignCodeValidRequested, getCampaignCodeValidRejected } =
  createActions({
    getCampaignCodeValidRequested: () => ({}),
    getCampaignCodeValidRejected: (error: any) => ({}),
  })

export const getCampaignCodeValid = (
  campaignCode: string,
  categoryId: number
) =>
  get({
    url: `/item/campaignCodeValid?${`campaignCode=${campaignCode}&categoryId=${categoryId}`}`,
    initiated: getCampaignCodeValidRequested,
    fulfilled: (campaignCodeValid: boolean) =>
      getCampaignCodeValidSucceeded(campaignCodeValid),
    rejected: getCampaignCodeValidRejected,
  })

export const openAlertContainer =
  ({ message, alertType }: { message: string; alertType: string }) =>
  async () => {
    if (!message || !alertType) return
    switch (alertType) {
      case alertTypes.default:
        toast(message, alertSettings)
        break
      case alertTypes.success:
        toast.success(message, alertSettings)
        break
      case alertTypes.info:
        toast.info(message, alertSettings)
        break
      case alertTypes.warning:
        toast.warning(message, alertSettings)
        break
      case alertTypes.error:
        toast.error(message, alertSettings)
        break
    }
  }
